import * as React from 'react';
import { isMobile } from 'react-device-detect';
import { Block, Heading, Text } from '../../../../../components';
import iconSuccess from '../../../../../../assets/illustrations/error-files.svg';
import IDHelpers from '../../../../../../core/helpers/IDHelper';
import { InteractiveButton } from '../../../components';

interface ErrorMessageProps {
  onClickPrimary: () => void;
}
const ErrorMessage = (props: ErrorMessageProps) => {
  const { onClickPrimary } = props;
  return (
    <Block
      customized
      maxWidth={isMobile ? '100%' : '496px'}
      backgroundColor="#fff"
      padding="0px 32px 32px 32px"
      margin="8px 0px 0px 0px"
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <Block
        customized
        display="flex"
        justifyContent="center"
        alignItems="center"
        margin="0px 0px 16px"
      >
        <img src={iconSuccess} alt="" />
      </Block>
      <Heading
        key={IDHelpers.generateID()}
        text="Ocurrió un problema inesperado"
        level={2}
        color="#161D1F"
        size={20}
        lineHeight={32}
        fontWeight="900"
        className=""
        align="center"
        width="100%"
      />
      <Text
        key={IDHelpers.generateID()}
        textAlign="center"
        fontWeight="400"
        fontSize="14px"
        lineHeight="20px"
        style={{ marginTop: 16 }}
      >
        Por favor, vuelve a intentarlo.
      </Text>
      <Block
        customized
        margin="32px 0 0 0"
        flexDirection={isMobile ? 'column' : 'row'}
        alignItems="center"
        justifyContent="center"
      >
        <Block
          style={{
            alignSelf: isMobile ? 'center' : 'flex-start',
            width: isMobile ? '100%' : 'auto'
          }}
        >
          <InteractiveButton
            bkgColorEnabled="#5B36F2"
            bkgColorHover="#745EF6"
            bkgColorFocus="#4318CD"
            bkgColorPressed="#4318CD"
            customized
            alignItems="center"
            backgroundColor="#5B36F2"
            padding="10px 0px"
            borderRadius="4px"
            width={isMobile ? '100%' : '99px'}
            onClick={onClickPrimary}
          >
            <Text
              color="#FFFFFF"
              fontSize="14px"
              lineHeight="20px"
              fontWeight="700"
              textAlign="center"
            >
              Reintentar
            </Text>
          </InteractiveButton>
        </Block>
      </Block>
    </Block>
  );
};
export default ErrorMessage;
